module.exports = __webpack_public_path__ + "static/media/video.8bde9262.mp4";